import {
    MOVE_ITEM_FAILURE
} from '../actionTypes';

export const moveItemFailure = payload => ({
    type: MOVE_ITEM_FAILURE
})